import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
};

export type AdminDto = {
  __typename?: 'AdminDto';
  _type?: Maybe<Array<Scalars['String']>>;
  active: Scalars['Boolean'];
  avatar?: Maybe<Scalars['String']>;
  custodiaID?: Maybe<Scalars['String']>;
  disableIpRestrictedAccess?: Maybe<Scalars['Boolean']>;
  email: Scalars['String'];
  emailName: Scalars['String'];
  eurConverted?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  newRoles?: Maybe<Array<Scalars['String']>>;
  password: Scalars['String'];
  pause?: Maybe<AdminPauseDto>;
  phone: Scalars['String'];
  phoneExt: Scalars['Int'];
  phoneIPAddress: Scalars['String'];
  roles: AdminRolesDto;
  sdaDefaultReports?: Maybe<Array<Scalars['String']>>;
  signature: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  systemConfig?: Maybe<AdminSystemConfigDto>;
  tcNumber?: Maybe<Scalars['String']>;
  teamleaderId?: Maybe<Scalars['String']>;
};

export type AdminInput = {
  _type?: InputMaybe<Array<Scalars['String']>>;
  active: Scalars['Boolean'];
  avatar?: InputMaybe<Scalars['String']>;
  custodiaID?: InputMaybe<Scalars['String']>;
  disableIpRestrictedAccess?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  emailName: Scalars['String'];
  eurConverted?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  newRoles?: InputMaybe<Array<Scalars['String']>>;
  password: Scalars['String'];
  pause?: InputMaybe<AdminPauseInput>;
  phone: Scalars['String'];
  phoneExt: Scalars['Int'];
  phoneIPAddress: Scalars['String'];
  roles: AdminRolesInput;
  sdaDefaultReports?: InputMaybe<Array<Scalars['String']>>;
  signature: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  systemConfig?: InputMaybe<AdminSystemConfigInput>;
  tcNumber?: InputMaybe<Scalars['String']>;
  teamleaderId?: InputMaybe<Scalars['String']>;
};

export type AdminPauseDto = {
  __typename?: 'AdminPauseDto';
  duration?: Maybe<Scalars['Int']>;
  latestPauseTimeStamp?: Maybe<Scalars['String']>;
  pauseType?: Maybe<Scalars['String']>;
};

export type AdminPauseInput = {
  duration?: InputMaybe<Scalars['Int']>;
  latestPauseTimeStamp?: InputMaybe<Scalars['String']>;
  pauseType?: InputMaybe<Scalars['String']>;
};

export type AdminRolesDto = {
  __typename?: 'AdminRolesDto';
  aoAgent: Scalars['Boolean'];
  cms: Scalars['Boolean'];
  developer: Scalars['Boolean'];
  dzoAgentGraph: Scalars['Boolean'];
  editableStaticContent: Scalars['Boolean'];
  kaskoQualified: Scalars['Boolean'];
  kpas: Scalars['Boolean'];
  loanAgent?: Maybe<Scalars['Boolean']>;
  loanBackOffice?: Maybe<Scalars['Boolean']>;
  loanOptimumAgent?: Maybe<Scalars['Boolean']>;
  marketing: Scalars['Boolean'];
  rapidMinerAdmin: Scalars['Boolean'];
  reAssign: Scalars['Boolean'];
  receivesAutoEmails: Scalars['Boolean'];
  sales: Scalars['Boolean'];
  salesTarget: Scalars['Int'];
  salesTargetBase: Scalars['Int'];
  savaBusinessDiscount: Scalars['Boolean'];
  superAdmin: Scalars['Boolean'];
  support: Scalars['Boolean'];
  tariff: Scalars['Boolean'];
  telcoAgentMultibrand: Scalars['Boolean'];
  winchAssignLimit: Scalars['Int'];
  winchUser: Scalars['Boolean'];
  winchWeekLimit: Scalars['Int'];
};

export type AdminRolesInput = {
  aoAgent: Scalars['Boolean'];
  cms: Scalars['Boolean'];
  developer: Scalars['Boolean'];
  dzoAgentGraph: Scalars['Boolean'];
  editableStaticContent: Scalars['Boolean'];
  kaskoQualified: Scalars['Boolean'];
  kpas: Scalars['Boolean'];
  loanAgent?: InputMaybe<Scalars['Boolean']>;
  loanBackOffice?: InputMaybe<Scalars['Boolean']>;
  loanOptimumAgent?: InputMaybe<Scalars['Boolean']>;
  marketing: Scalars['Boolean'];
  rapidMinerAdmin: Scalars['Boolean'];
  reAssign: Scalars['Boolean'];
  receivesAutoEmails: Scalars['Boolean'];
  sales: Scalars['Boolean'];
  salesTarget: Scalars['Int'];
  salesTargetBase: Scalars['Int'];
  savaBusinessDiscount: Scalars['Boolean'];
  superAdmin: Scalars['Boolean'];
  support: Scalars['Boolean'];
  tariff: Scalars['Boolean'];
  telcoAgentMultibrand: Scalars['Boolean'];
  winchAssignLimit: Scalars['Int'];
  winchUser: Scalars['Boolean'];
  winchWeekLimit: Scalars['Int'];
};

export type AdminSystemConfigDto = {
  __typename?: 'AdminSystemConfigDto';
  winchDeassign?: Maybe<Scalars['Boolean']>;
};

export type AdminSystemConfigInput = {
  winchDeassign?: InputMaybe<Scalars['Boolean']>;
};

export type Brand = {
  code: Scalars['String'];
  logos?: InputMaybe<BrandLogo>;
  name: Scalars['String'];
  paymentInfo?: InputMaybe<PaymentInfo>;
};

export type BrandDto = {
  __typename?: 'BrandDto';
  code: Scalars['String'];
  logos?: Maybe<BrandLogoDto>;
  name: Scalars['String'];
  paymentInfo?: Maybe<PaymentInfoDto>;
};

export type BrandLogo = {
  dzo?: InputMaybe<BrandLogoDzo>;
};

export type BrandLogoDto = {
  __typename?: 'BrandLogoDto';
  dzo?: Maybe<BrandLogoDzoDto>;
};

export type BrandLogoDzo = {
  details?: InputMaybe<Scalars['String']>;
  results?: InputMaybe<Scalars['String']>;
};

export type BrandLogoDzoDto = {
  __typename?: 'BrandLogoDzoDto';
  details?: Maybe<Scalars['String']>;
  results?: Maybe<Scalars['String']>;
};

export type BrandModifierDto = {
  __typename?: 'BrandModifierDto';
  defaulNumber?: Maybe<Scalars['Float']>;
  default: Scalars['JSON'];
  defaultBoolean?: Maybe<Scalars['Boolean']>;
  field: Scalars['String'];
  fixed?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type Building = {
  coverages: Array<Coverage>;
  package: Package;
  quote?: InputMaybe<Scalars['Float']>;
};

export type BuildingDto = {
  __typename?: 'BuildingDto';
  coverages: Array<CoverageDto>;
  package: PackageDto;
  quote?: Maybe<Scalars['Float']>;
};

export type CalculationClaims = {
  insuredAmount: Scalars['Float'];
  name: Scalars['String'];
  premium: Scalars['Float'];
};

export type CalculationClaimsDto = {
  __typename?: 'CalculationClaimsDto';
  insuredAmount: Scalars['Float'];
  name: Scalars['String'];
  premium: Scalars['Float'];
};

export type CalculationCoverage = {
  code: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  insuredAmount?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  premium?: InputMaybe<Scalars['Float']>;
  risks?: InputMaybe<Array<CalculationRisks>>;
};

export type CalculationCoverageDto = {
  __typename?: 'CalculationCoverageDto';
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  insuredAmount?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  premium?: Maybe<Scalars['Float']>;
  risks?: Maybe<Array<CalculationRisksDto>>;
};

export type CalculationData = {
  additionalCoverages?: InputMaybe<Array<CalculationCoverage>>;
  calculationId?: InputMaybe<Scalars['String']>;
  commercialDiscount?: InputMaybe<Scalars['Boolean']>;
  contractId?: InputMaybe<Scalars['String']>;
  contractorId?: InputMaybe<Scalars['String']>;
  coverages?: InputMaybe<Array<CalculationCoverage>>;
  installmentsCalculationId?: InputMaybe<Scalars['String']>;
  installmentsPremium?: InputMaybe<Scalars['Float']>;
  insuredInterestId?: InputMaybe<Scalars['String']>;
  insuredPersonId?: InputMaybe<Scalars['String']>;
  isFlood?: InputMaybe<Scalars['Boolean']>;
  nonStandardRequestToggle?: InputMaybe<Scalars['Boolean']>;
  packageCode?: InputMaybe<Scalars['String']>;
  packageName?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
  singleCalculationId?: InputMaybe<Scalars['String']>;
  singlePremium?: InputMaybe<Scalars['Float']>;
};

export type CalculationDto = {
  __typename?: 'CalculationDto';
  brandsWithProducts: Array<PropertyBrandWithProducts>;
  timestamp: Scalars['String'];
};

export type CalculationInput = {
  brandCode?: InputMaybe<Scalars['String']>;
  buildingInsurance?: InputMaybe<Scalars['Boolean']>;
  commercialDiscount?: InputMaybe<Scalars['Boolean']>;
  contractor?: InputMaybe<ContractorInput>;
  householdInsurance?: InputMaybe<Scalars['Boolean']>;
  insuranceQuotes: InsuranceQuotesInput;
  insuredPerson?: InputMaybe<InsuredPersonInput>;
  isFlood?: InputMaybe<Scalars['Boolean']>;
  nonStandardRequestToggle?: InputMaybe<Scalars['Boolean']>;
  offerId?: InputMaybe<Scalars['String']>;
  packageCode?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  policyDuration?: InputMaybe<Scalars['Int']>;
  policyStartDate?: InputMaybe<Scalars['String']>;
  propertyInfo: PropertyInfoInput;
  selectedCoverages?: InputMaybe<Array<SelectedCoveragesInput>>;
  sessionId?: InputMaybe<Scalars['String']>;
  webshopCalc?: InputMaybe<Array<Scalars['String']>>;
};

export type CalculationInputData = {
  additionalCoverages?: InputMaybe<Array<CalculationCoverage>>;
  buildingQuote?: InputMaybe<Scalars['Float']>;
  calculationId?: InputMaybe<Scalars['String']>;
  commercialDiscount?: InputMaybe<Scalars['Boolean']>;
  contractId?: InputMaybe<Scalars['String']>;
  contractorId?: InputMaybe<Scalars['String']>;
  coverages?: InputMaybe<Array<CalculationCoverage>>;
  householdQuote?: InputMaybe<Scalars['Float']>;
  installmentsCalculationId?: InputMaybe<Scalars['String']>;
  installmentsPremium?: InputMaybe<Scalars['Float']>;
  insuredInterestId?: InputMaybe<Scalars['String']>;
  insuredPersonId?: InputMaybe<Scalars['String']>;
  isFlood?: InputMaybe<Scalars['Boolean']>;
  nonStandardRequestToggle?: InputMaybe<Scalars['Boolean']>;
  packageCode?: InputMaybe<Scalars['String']>;
  packageName?: InputMaybe<Scalars['String']>;
  policyDuration?: InputMaybe<Scalars['Float']>;
  policyStartDate?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
  singleCalculationId?: InputMaybe<Scalars['String']>;
  singlePremium?: InputMaybe<Scalars['Float']>;
  totalPremium?: InputMaybe<Scalars['Float']>;
};

export type CalculationInputDataDto = {
  __typename?: 'CalculationInputDataDto';
  additionalCoverages?: Maybe<Array<CalculationCoverageDto>>;
  buildingQuote?: Maybe<Scalars['Float']>;
  calculationId?: Maybe<Scalars['String']>;
  commercialDiscount?: Maybe<Scalars['Boolean']>;
  contractId?: Maybe<Scalars['String']>;
  contractorId?: Maybe<Scalars['String']>;
  coverages?: Maybe<Array<CalculationCoverageDto>>;
  householdQuote?: Maybe<Scalars['Float']>;
  installmentsCalculationId?: Maybe<Scalars['String']>;
  installmentsPremium?: Maybe<Scalars['Float']>;
  insuredInterestId?: Maybe<Scalars['String']>;
  insuredPersonId?: Maybe<Scalars['String']>;
  isFlood?: Maybe<Scalars['Boolean']>;
  nonStandardRequestToggle?: Maybe<Scalars['Boolean']>;
  packageCode?: Maybe<Scalars['String']>;
  packageName?: Maybe<Scalars['String']>;
  policyDuration?: Maybe<Scalars['Float']>;
  policyStartDate?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
  singleCalculationId?: Maybe<Scalars['String']>;
  singlePremium?: Maybe<Scalars['Float']>;
  totalPremium?: Maybe<Scalars['Float']>;
};

export type CalculationResultEvent = {
  __typename?: 'CalculationResultEvent';
  brandCode: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  isLast: Scalars['Boolean'];
  result?: Maybe<Array<PropertyBrandWithProducts>>;
  subscriptionId: Scalars['String'];
};

export type CalculationRisks = {
  claims?: InputMaybe<Array<CalculationClaims>>;
  code: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  insuredAmount?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  premium?: InputMaybe<Scalars['Float']>;
};

export type CalculationRisksDto = {
  __typename?: 'CalculationRisksDto';
  claims?: Maybe<Array<CalculationClaimsDto>>;
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  insuredAmount?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  premium?: Maybe<Scalars['Float']>;
};

export type CallMeInput = {
  number: Scalars['String'];
  product: Scalars['String'];
  soId?: InputMaybe<Scalars['String']>;
};

export type ConsentData = {
  allianzGDPR?: InputMaybe<Scalars['Boolean']>;
  emailDocumentationConsent?: InputMaybe<Scalars['Boolean']>;
  fourteenDayCancellationPolicy?: InputMaybe<Scalars['Boolean']>;
  generalTOSConsent?: InputMaybe<Scalars['Boolean']>;
  iddConsent?: InputMaybe<Scalars['Boolean']>;
  uniqaTermsAccepted?: InputMaybe<Scalars['Boolean']>;
  validDataConsent?: InputMaybe<Scalars['Boolean']>;
};

export type ConsentInput = {
  consent: ConsentData;
};

export type ConstructionYearInput = {
  before1964: Scalars['Boolean'];
  exactYear: Scalars['Int'];
};

export type ContractorInput = {
  city?: InputMaybe<Scalars['String']>;
  cityKompareId?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  houseNumber?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  oib?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  sameAddressAsProperty?: InputMaybe<Scalars['Boolean']>;
  sameAsInsured?: InputMaybe<Scalars['Boolean']>;
  street?: InputMaybe<Scalars['String']>;
  streetKompareId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PersonType>;
  zipCode?: InputMaybe<Scalars['Int']>;
};

export type Coverage = {
  code: Scalars['String'];
  description: Scalars['String'];
  label: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  propertyType: Array<Scalars['String']>;
};

export type CoverageDto = {
  __typename?: 'CoverageDto';
  code: Scalars['String'];
  description: Scalars['String'];
  label: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  propertyType: Array<Scalars['String']>;
};

export type CreateOfferInput = {
  additionalCoverages?: InputMaybe<Array<CalculationCoverage>>;
  brandId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  product?: InputMaybe<OfferProductWithCalculation>;
  soId?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

export type CreateSoInput = {
  data: SoDataInput;
  productTypeSpecific?: InputMaybe<SoPropertyTypeSpecificInput>;
  soId?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  visitorIds?: InputMaybe<Array<Scalars['String']>>;
};

export type FinishPaymentResponse = {
  __typename?: 'FinishPaymentResponse';
  alreadyPaid?: Maybe<Scalars['Boolean']>;
  message: Scalars['String'];
  policyNumber?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type GeneralTransferDetailsDto = {
  __typename?: 'GeneralTransferDetailsDto';
  customerAddress?: Maybe<Scalars['String']>;
  customerCity?: Maybe<Scalars['String']>;
  customerCountry: Scalars['String'];
  customerEmail?: Maybe<Scalars['String']>;
  customerFirstName?: Maybe<Scalars['String']>;
  customerLastName?: Maybe<Scalars['String']>;
  customerOib?: Maybe<Scalars['String']>;
  customerPhone?: Maybe<Scalars['String']>;
  customerZipCode?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  numberOfInstallments: Scalars['Int'];
  price: Scalars['Float'];
  recipientAccountNumber?: Maybe<Scalars['String']>;
  recipientAddress?: Maybe<Scalars['String']>;
  recipientCity?: Maybe<Scalars['String']>;
  recipientName?: Maybe<Scalars['String']>;
  recipientZipCode?: Maybe<Scalars['String']>;
  referenceNumber?: Maybe<Scalars['String']>;
  referenceNumberType?: Maybe<Scalars['String']>;
  referencePrefix?: Maybe<Scalars['String']>;
  referenceSuffix?: Maybe<Scalars['String']>;
};

export type GetOfferDto = {
  __typename?: 'GetOfferDto';
  _id: Scalars['String'];
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['Boolean']>;
  departmentCode?: Maybe<Scalars['String']>;
  offerNumber: Scalars['String'];
  productTypeId: Scalars['String'];
  productTypeSpecific: OfferProductTypeSpecificDto;
  soId: Scalars['String'];
  status: Scalars['String'];
  updatedAt?: Maybe<Scalars['String']>;
};

export type GetOffersBySoDto = {
  __typename?: 'GetOffersBySoDto';
  offers: Array<GetOfferDto>;
};

export type GetSoDto = {
  __typename?: 'GetSoDto';
  _id: Scalars['String'];
  adminId?: Maybe<AdminDto>;
  archived?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  customerId?: Maybe<SoCustomerDto>;
  data?: Maybe<SoDataDto>;
  deleted?: Maybe<Scalars['Boolean']>;
  departmentCode?: Maybe<Scalars['String']>;
  encryptedId?: Maybe<Scalars['String']>;
  flags?: Maybe<SoFlagsDto>;
  funnel?: Maybe<SoFunnelDto>;
  hotProspect?: Maybe<Scalars['Boolean']>;
  partnerAdvisorId?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  productTypeId?: Maybe<SoProductTypeDto>;
  productTypeSpecific?: Maybe<SoProductTypeSpecificDto>;
  soNumber: Scalars['Int'];
  source?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  termsAcceptedAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type Household = {
  coverages: Array<Coverage>;
  package: Package;
  quote?: InputMaybe<Scalars['Float']>;
};

export type HouseholdDto = {
  __typename?: 'HouseholdDto';
  coverages: Array<CoverageDto>;
  package: PackageDto;
  quote?: Maybe<Scalars['Float']>;
};

export type InsuranceQuotesInput = {
  building: Scalars['Float'];
  household: Scalars['Float'];
};

export type InsuredPersonInput = {
  city?: InputMaybe<Scalars['String']>;
  cityKompareId?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  houseNumber?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  oib?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  sameAddressAsProperty?: InputMaybe<Scalars['Boolean']>;
  street?: InputMaybe<Scalars['String']>;
  streetKompareId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PersonType>;
  zipCode?: InputMaybe<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptTerms: Scalars['Boolean'];
  callMe: Scalars['Boolean'];
  createOffer?: Maybe<GetOfferDto>;
  createSo: Scalars['String'];
  finishOfflinePurchase?: Maybe<Scalars['Boolean']>;
  finishPayment?: Maybe<FinishPaymentResponse>;
  recordPaymentError?: Maybe<Scalars['Boolean']>;
  removeVoucher?: Maybe<Scalars['Boolean']>;
  sendGeneralTransferDetailsToEmail?: Maybe<Scalars['String']>;
  startCalculations: Array<CalculationResultEvent>;
  updateCalculation: ProductCalculation;
  validateVoucher?: Maybe<VoucherValidateResponseDto>;
};


export type MutationAcceptTermsArgs = {
  calculationInput?: InputMaybe<CalculationInput>;
  consent: ConsentInput;
  id: Scalars['String'];
  input?: InputMaybe<SetContractorAndInsuredPersonInput>;
  offerId: Scalars['String'];
};


export type MutationCallMeArgs = {
  input: CallMeInput;
};


export type MutationCreateOfferArgs = {
  data: CreateOfferInput;
};


export type MutationCreateSoArgs = {
  input: CreateSoInput;
};


export type MutationFinishOfflinePurchaseArgs = {
  offerId: Scalars['String'];
};


export type MutationFinishPaymentArgs = {
  offerId: Scalars['String'];
  wsPayParams: WsPayResp;
};


export type MutationRecordPaymentErrorArgs = {
  errorCode: Scalars['String'];
  errorMessage: Scalars['String'];
  offerId: Scalars['String'];
};


export type MutationRemoveVoucherArgs = {
  offerId: Scalars['String'];
};


export type MutationSendGeneralTransferDetailsToEmailArgs = {
  installments: Scalars['Int'];
  offerId: Scalars['String'];
};


export type MutationStartCalculationsArgs = {
  input: CalculationInput;
  subscriptionId: Scalars['String'];
};


export type MutationUpdateCalculationArgs = {
  input: CalculationInput;
};


export type MutationValidateVoucherArgs = {
  offerId: Scalars['String'];
  voucherCode: Scalars['String'];
};

export type NewPolicy = {
  cancelContract?: InputMaybe<Scalars['Boolean']>;
  newPolicyEndDate?: InputMaybe<Scalars['String']>;
  newPolicyStartDate: Scalars['String'];
  policyDuration: Scalars['Float'];
};

export type NewPolicyDto = {
  __typename?: 'NewPolicyDto';
  cancelContract?: Maybe<Scalars['Boolean']>;
  newPolicyEndDate?: Maybe<Scalars['String']>;
  newPolicyStartDate: Scalars['String'];
  policyDuration: Scalars['Float'];
};

export type OfferCalculationDataDto = {
  __typename?: 'OfferCalculationDataDto';
  additionalCoverages?: Maybe<Array<CalculationCoverageDto>>;
  calculationId?: Maybe<Scalars['String']>;
  commercialDiscount?: Maybe<Scalars['Boolean']>;
  contractId?: Maybe<Scalars['String']>;
  contractorId?: Maybe<Scalars['String']>;
  coverages?: Maybe<Array<CalculationCoverageDto>>;
  installmentsCalculationId?: Maybe<Scalars['String']>;
  installmentsPremium?: Maybe<Scalars['Float']>;
  insuredInterestId?: Maybe<Scalars['String']>;
  insuredPersonId?: Maybe<Scalars['String']>;
  isFlood?: Maybe<Scalars['Boolean']>;
  nonStandardRequestToggle?: Maybe<Scalars['Boolean']>;
  packageCode?: Maybe<Scalars['String']>;
  packageName?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
  singleCalculationId?: Maybe<Scalars['String']>;
  singlePremium?: Maybe<Scalars['Float']>;
};

export type OfferFileDocumentDto = {
  __typename?: 'OfferFileDocumentDto';
  downloadLink: Scalars['String'];
  fileId: Scalars['String'];
  fileName: Scalars['String'];
};

export type OfferFilesGetDto = {
  __typename?: 'OfferFilesGetDto';
  documents: Array<OfferFileDocumentDto>;
};

export type OfferProductTypeSpecificDto = {
  __typename?: 'OfferProductTypeSpecificDto';
  attachedDocuments?: Maybe<Array<Scalars['String']>>;
  brandId: BrandDto;
  building: BuildingDto;
  calculationData?: Maybe<OfferCalculationDataDto>;
  household: HouseholdDto;
  isPublished: Scalars['Boolean'];
  lastPaymentAttempt?: Maybe<Scalars['String']>;
  newPolicy: Array<NewPolicyDto>;
  numberOfInstallments?: Maybe<Scalars['Float']>;
  paidAt?: Maybe<Scalars['String']>;
  payment: PaymentDto;
  paymentMethod?: Maybe<Scalars['String']>;
  paymentPlan?: Maybe<Scalars['String']>;
  policyLengthType?: Maybe<Scalars['String']>;
  shoppingCartId: Scalars['Float'];
  termsAndConditions?: Maybe<Array<Scalars['String']>>;
  termsLink?: Maybe<Scalars['String']>;
  wsPayResponse?: Maybe<WsPayResponseDto>;
};

export type OfferProductWithCalculation = {
  _id: Scalars['String'];
  actionLabel?: InputMaybe<Scalars['String']>;
  calculation?: InputMaybe<CalculationInputData>;
  code: Scalars['String'];
  name: Scalars['String'];
  partnerId?: InputMaybe<PartnerId>;
  productTypeSpecific: ProductProductTypeSpecific;
  termsLink?: InputMaybe<Scalars['String']>;
};

export type OfferTermsAndConditionsDocumentDto = {
  __typename?: 'OfferTermsAndConditionsDocumentDto';
  fileId: Scalars['String'];
  fileName: Scalars['String'];
  src: Scalars['String'];
};

export type OfferTermsAndConditionsGetDto = {
  __typename?: 'OfferTermsAndConditionsGetDto';
  brandCode: Scalars['String'];
  brandLogo?: Maybe<Scalars['String']>;
  brandName: Scalars['String'];
  documents: Array<OfferTermsAndConditionsDocumentDto>;
  productName: Scalars['String'];
};

export type OfferTermsAndConditionsInput = {
  brandCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  productCodes?: InputMaybe<Array<Scalars['String']>>;
  productName?: InputMaybe<Scalars['String']>;
};

export type OfferTypeSpecific = {
  attachedDocuments?: InputMaybe<Array<Scalars['String']>>;
  brandId: Brand;
  building: Building;
  calculationData?: InputMaybe<CalculationData>;
  household: Household;
  isPublished: Scalars['Boolean'];
  lastPaymentAttempt?: InputMaybe<Scalars['String']>;
  newPolicy: Array<NewPolicy>;
  numberOfInstallments?: InputMaybe<Scalars['Float']>;
  paidAt?: InputMaybe<Scalars['String']>;
  payment: Payment;
  paymentMethod?: InputMaybe<Scalars['String']>;
  paymentPlan?: InputMaybe<Scalars['String']>;
  policyLengthType?: InputMaybe<Scalars['String']>;
  shoppingCartId: Scalars['Float'];
  termsAndConditions?: InputMaybe<Array<Scalars['String']>>;
  termsLink?: InputMaybe<Scalars['String']>;
  wsPayResponse?: InputMaybe<WsPayResp>;
};

export type Package = {
  code: Scalars['String'];
  description: Scalars['String'];
  label: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  propertyType: Array<Scalars['String']>;
};

export type PackageDto = {
  __typename?: 'PackageDto';
  code: Scalars['String'];
  description: Scalars['String'];
  label: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  propertyType: Array<Scalars['String']>;
};

export type PartnerId = {
  contractor?: InputMaybe<Scalars['String']>;
  insuredPerson?: InputMaybe<Scalars['String']>;
};

export type PartnerIdDto = {
  __typename?: 'PartnerIdDto';
  contractor?: Maybe<Scalars['String']>;
  insuredPerson?: Maybe<Scalars['String']>;
};

export type Payment = {
  basePremium: Scalars['Float'];
  discount: Scalars['Float'];
  installmentsPremium?: InputMaybe<Scalars['Float']>;
  paymentMethod: Scalars['String'];
  singlePremium?: InputMaybe<Scalars['Float']>;
  totalPremium: Scalars['Float'];
  voucher?: InputMaybe<Scalars['String']>;
};

export type PaymentDto = {
  __typename?: 'PaymentDto';
  basePremium: Scalars['Float'];
  discount: Scalars['Float'];
  installmentsPremium?: Maybe<Scalars['Float']>;
  paymentMethod: Scalars['String'];
  singlePremium?: Maybe<Scalars['Float']>;
  totalPremium: Scalars['Float'];
  voucher?: Maybe<Scalars['String']>;
};

export type PaymentInfo = {
  accountNumber?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<PaymentInfoDzoString>;
  dzo?: InputMaybe<PaymentInfoDzo>;
  model?: InputMaybe<PaymentInfoDzoString>;
  recipientName?: InputMaybe<Scalars['String']>;
  referenceNumberType?: InputMaybe<Scalars['String']>;
  referencePrefix?: InputMaybe<PaymentInfoDzoString>;
  referenceSufix?: InputMaybe<Scalars['String']>;
};

export type PaymentInfoDto = {
  __typename?: 'PaymentInfoDto';
  accountNumber?: Maybe<Scalars['String']>;
  description?: Maybe<PaymentInfoDzoStringDto>;
  dzo?: Maybe<PaymentInfoDzoDto>;
  model?: Maybe<PaymentInfoDzoStringDto>;
  recipientName?: Maybe<Scalars['String']>;
  referenceNumberType?: Maybe<Scalars['String']>;
  referencePrefix?: Maybe<PaymentInfoDzoStringDto>;
  referenceSufix?: Maybe<Scalars['String']>;
};

export type PaymentInfoDzo = {
  accountNumber?: InputMaybe<Scalars['String']>;
  recipientName?: InputMaybe<Scalars['String']>;
};

export type PaymentInfoDzoDto = {
  __typename?: 'PaymentInfoDzoDto';
  accountNumber?: Maybe<Scalars['String']>;
  recipientName?: Maybe<Scalars['String']>;
};

export type PaymentInfoDzoString = {
  dzo?: InputMaybe<Scalars['String']>;
};

export type PaymentInfoDzoStringDto = {
  __typename?: 'PaymentInfoDzoStringDto';
  dzo?: Maybe<Scalars['String']>;
};

export enum PersonType {
  Legal = 'LEGAL',
  Physical = 'PHYSICAL'
}

export type ProductCalculation = {
  __typename?: 'ProductCalculation';
  error?: Maybe<Scalars['String']>;
  packages: Array<StandardizedPackage>;
  partnerId?: Maybe<PartnerIdDto>;
  success: Scalars['Boolean'];
};

export type ProductCoverage = {
  code?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  disables?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
};

export type ProductModifier = {
  defaulNumber?: InputMaybe<Scalars['Float']>;
  default: Scalars['JSON'];
  defaultBoolean?: InputMaybe<Scalars['Boolean']>;
  field: Scalars['String'];
  fixed?: InputMaybe<Scalars['Float']>;
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type ProductProductTypeSpecific = {
  coverages: Array<ProductCoverage>;
  description?: InputMaybe<Scalars['String']>;
  isIndependant?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  modifiers?: InputMaybe<Array<ProductModifier>>;
  propertyType?: InputMaybe<Scalars['String']>;
};

export type ProductProductTypeSpecificDto = {
  __typename?: 'ProductProductTypeSpecificDto';
  coverages: Array<ProductPropertyCoverageDto>;
  description?: Maybe<Scalars['String']>;
  isIndependant?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  modifiers?: Maybe<Array<BrandModifierDto>>;
  propertyType?: Maybe<Scalars['String']>;
};

export type ProductPropertyCoverageDto = {
  __typename?: 'ProductPropertyCoverageDto';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  disables?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export type PropertyBrandWithProducts = {
  __typename?: 'PropertyBrandWithProducts';
  _id: Scalars['String'];
  code: Scalars['String'];
  name: Scalars['String'];
  products: Array<PropertyProductWithCalculation>;
  ptsLogo?: Maybe<Scalars['String']>;
};

export type PropertyInfoInput = {
  area: Scalars['Float'];
  city: Scalars['String'];
  cityKompareId: Scalars['String'];
  cityParentName?: InputMaybe<Scalars['String']>;
  constructionYear: ConstructionYearInput;
  floor: Array<Scalars['String']>;
  houseNumber: Scalars['String'];
  masonry: Scalars['Boolean'];
  nonstandardRequests?: InputMaybe<Scalars['String']>;
  street: Scalars['String'];
  streetKompareId: Scalars['String'];
  type: Scalars['String'];
  usage: Scalars['String'];
  zipCode: Scalars['Int'];
};

export type PropertyProductWithCalculation = {
  __typename?: 'PropertyProductWithCalculation';
  _id: Scalars['String'];
  actionLabel?: Maybe<Scalars['String']>;
  calculation?: Maybe<StandardizedPackage>;
  code: Scalars['String'];
  name: Scalars['String'];
  partnerId?: Maybe<PartnerIdDto>;
  productTypeSpecific: ProductProductTypeSpecificDto;
};

export type Query = {
  __typename?: 'Query';
  getAdmins?: Maybe<Array<AdminDto>>;
  getCalculationByBrand: PropertyBrandWithProducts;
  getCalculations: CalculationDto;
  getFilesFromOffer?: Maybe<OfferFilesGetDto>;
  getGeneralTransferDetails?: Maybe<GeneralTransferDetailsDto>;
  getOffer?: Maybe<GetOfferDto>;
  getOffersBySo?: Maybe<GetOffersBySoDto>;
  getSo?: Maybe<GetSoDto>;
  getTermsAndConditionsForOffer?: Maybe<OfferTermsAndConditionsGetDto>;
  getWSPayPaymentDetails?: Maybe<WsPayPaymentDetailsDto>;
};


export type QueryGetCalculationByBrandArgs = {
  brandCode: Scalars['String'];
  input: CalculationInput;
};


export type QueryGetCalculationsArgs = {
  input: CalculationInput;
};


export type QueryGetFilesFromOfferArgs = {
  id: Scalars['String'];
};


export type QueryGetGeneralTransferDetailsArgs = {
  installments: Scalars['Int'];
  offerId: Scalars['String'];
};


export type QueryGetOfferArgs = {
  id: Scalars['String'];
};


export type QueryGetOffersBySoArgs = {
  soId: Scalars['String'];
};


export type QueryGetSoArgs = {
  id: Scalars['String'];
};


export type QueryGetTermsAndConditionsForOfferArgs = {
  data: OfferTermsAndConditionsInput;
  id?: InputMaybe<Scalars['String']>;
};


export type QueryGetWsPayPaymentDetailsArgs = {
  id: Scalars['String'];
  installments?: InputMaybe<Scalars['Int']>;
  paymentType: Scalars['String'];
};

export type SelectedCoveragesInput = {
  brandCode: Scalars['String'];
  coverageCode: Scalars['String'];
};

export type SetContractorAndInsuredPersonInput = {
  contractor: SoPropertyContractorInput;
  insured: SoPropertyPersonInput;
};

export type SoCustomerDto = {
  __typename?: 'SoCustomerDto';
  _id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type SoDataDto = {
  __typename?: 'SoDataDto';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  partner?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type SoDataInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  partner?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type SoFlagsDto = {
  __typename?: 'SoFlagsDto';
  archived?: Maybe<Scalars['Boolean']>;
  incomplete?: Maybe<Scalars['Boolean']>;
  incompleteResolved?: Maybe<Scalars['Boolean']>;
  offerCreated?: Maybe<Scalars['Boolean']>;
  offerDocumentAccepted?: Maybe<Scalars['Boolean']>;
  offerDocumentSent?: Maybe<Scalars['Boolean']>;
};

export type SoFunnelDto = {
  __typename?: 'SoFunnelDto';
  latestStep?: Maybe<Scalars['String']>;
  steps?: Maybe<Array<SoFunnelStepDto>>;
};

export type SoFunnelStepDto = {
  __typename?: 'SoFunnelStepDto';
  code: Scalars['String'];
  openedAt: Scalars['String'];
};

export type SoProductTypeDto = {
  __typename?: 'SoProductTypeDto';
  _id?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  departmentCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type SoProductTypeSpecificDto = {
  __typename?: 'SoProductTypeSpecificDto';
  contractor?: Maybe<SoPropertyContractorDto>;
  expectedCommissionAmount?: Maybe<Scalars['Float']>;
  insuranceNeeds?: Maybe<SoPropertyInsuranceNeedsDto>;
  insured?: Maybe<SoPropertyPersonDto>;
  propertyInfo?: Maybe<SoPropertyInfoDto>;
};

export type SoPropertyConstructionYearDto = {
  __typename?: 'SoPropertyConstructionYearDto';
  before1964: Scalars['Boolean'];
  exactYear: Scalars['Float'];
};

export type SoPropertyConstructionYearInput = {
  before1964: Scalars['Boolean'];
  exactYear: Scalars['Float'];
};

export type SoPropertyContractorDto = {
  __typename?: 'SoPropertyContractorDto';
  city?: Maybe<Scalars['String']>;
  cityKompareId?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  oib?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  sameAddressAsProperty?: Maybe<Scalars['Boolean']>;
  sameAsInsured?: Maybe<Scalars['Boolean']>;
  street?: Maybe<Scalars['String']>;
  streetKompareId?: Maybe<Scalars['String']>;
  type?: Maybe<PersonType>;
  zipCode?: Maybe<Scalars['Int']>;
};

export type SoPropertyContractorInput = {
  city?: InputMaybe<Scalars['String']>;
  cityKompareId?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  houseNumber?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  oib?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  sameAddressAsProperty?: InputMaybe<Scalars['Boolean']>;
  sameAsInsured?: InputMaybe<Scalars['Boolean']>;
  street?: InputMaybe<Scalars['String']>;
  streetKompareId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PersonType>;
  zipCode?: InputMaybe<Scalars['Int']>;
};

export type SoPropertyInfoDto = {
  __typename?: 'SoPropertyInfoDto';
  area?: Maybe<Scalars['Float']>;
  city?: Maybe<Scalars['String']>;
  cityKompareId?: Maybe<Scalars['String']>;
  cityParentName?: Maybe<Scalars['String']>;
  constructionYear?: Maybe<SoPropertyConstructionYearDto>;
  floor?: Maybe<Array<Scalars['String']>>;
  houseNumber?: Maybe<Scalars['String']>;
  masonry?: Maybe<Scalars['Boolean']>;
  nonstandardRequests?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  streetKompareId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  usage?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['Int']>;
};

export type SoPropertyInfoInput = {
  area?: InputMaybe<Scalars['Float']>;
  city?: InputMaybe<Scalars['String']>;
  cityKompareId?: InputMaybe<Scalars['String']>;
  cityParentName?: InputMaybe<Scalars['String']>;
  constructionYear?: InputMaybe<SoPropertyConstructionYearInput>;
  floor?: InputMaybe<Array<Scalars['String']>>;
  houseNumber?: InputMaybe<Scalars['String']>;
  masonry?: InputMaybe<Scalars['Boolean']>;
  nonstandardRequests?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  streetKompareId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  usage?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['Int']>;
};

export type SoPropertyInsuranceNeedsDto = {
  __typename?: 'SoPropertyInsuranceNeedsDto';
  building?: Maybe<Scalars['Boolean']>;
  personalProperty?: Maybe<Scalars['Boolean']>;
  risks?: Maybe<Array<Scalars['String']>>;
};

export type SoPropertyInsuranceNeedsInput = {
  building?: InputMaybe<Scalars['Boolean']>;
  personalProperty?: InputMaybe<Scalars['Boolean']>;
  risks?: InputMaybe<Array<Scalars['String']>>;
};

export type SoPropertyPersonDto = {
  __typename?: 'SoPropertyPersonDto';
  city?: Maybe<Scalars['String']>;
  cityKompareId?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  houseNumber?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  oib?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  sameAddressAsProperty?: Maybe<Scalars['Boolean']>;
  sameAsInsured?: Maybe<Scalars['Boolean']>;
  street?: Maybe<Scalars['String']>;
  streetKompareId?: Maybe<Scalars['String']>;
  type?: Maybe<PersonType>;
  zipCode?: Maybe<Scalars['Int']>;
};

export type SoPropertyPersonInput = {
  city?: InputMaybe<Scalars['String']>;
  cityKompareId?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  houseNumber?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  oib?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  sameAddressAsProperty?: InputMaybe<Scalars['Boolean']>;
  sameAsInsured?: InputMaybe<Scalars['Boolean']>;
  street?: InputMaybe<Scalars['String']>;
  streetKompareId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PersonType>;
  zipCode?: InputMaybe<Scalars['Int']>;
};

export type SoPropertyTypeSpecificInput = {
  contractor?: InputMaybe<SoPropertyContractorInput>;
  expectedCommissionAmount?: InputMaybe<Scalars['Float']>;
  insuranceNeeds?: InputMaybe<SoPropertyInsuranceNeedsInput>;
  insured?: InputMaybe<SoPropertyPersonInput>;
  propertyInfo?: InputMaybe<SoPropertyInfoInput>;
};

export type StandardClaim = {
  insuredAmount: Scalars['Float'];
  name: Scalars['String'];
  premium: Scalars['Float'];
};

export type StandardCoverage = {
  code: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  insuredAmount?: InputMaybe<Scalars['Float']>;
  isIncluded?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  premium?: InputMaybe<Scalars['Float']>;
  risks?: InputMaybe<Array<StandardRisk>>;
};

export type StandardPackage = {
  additionalCoverages: Array<StandardCoverage>;
  buildingQuote?: InputMaybe<Scalars['Float']>;
  calculationId?: InputMaybe<Scalars['String']>;
  coverages: Array<StandardCoverage>;
  householdQuote?: InputMaybe<Scalars['Float']>;
  installmentsCalculationId?: InputMaybe<Scalars['String']>;
  installmentsPremium?: InputMaybe<Scalars['Float']>;
  packageCode: Scalars['String'];
  packageName: Scalars['String'];
  policyDuration: Scalars['Float'];
  policyStartDate: Scalars['String'];
  sessionId?: InputMaybe<Scalars['String']>;
  singleCalculationId?: InputMaybe<Scalars['String']>;
  singlePremium?: InputMaybe<Scalars['Float']>;
  totalPremium: Scalars['Float'];
};

export type StandardRisk = {
  claims?: InputMaybe<Array<StandardClaim>>;
  code: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  insuredAmount?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  premium?: InputMaybe<Scalars['Float']>;
};

export type StandardizedClaims = {
  __typename?: 'StandardizedClaims';
  insuredAmount: Scalars['Float'];
  name: Scalars['String'];
  premium: Scalars['Float'];
};

export type StandardizedCoverage = {
  __typename?: 'StandardizedCoverage';
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  insuredAmount?: Maybe<Scalars['Float']>;
  isIncluded?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  premium?: Maybe<Scalars['Float']>;
  risks?: Maybe<Array<StandardizedRisk>>;
};

export type StandardizedPackage = {
  __typename?: 'StandardizedPackage';
  additionalCoverages: Array<StandardizedCoverage>;
  buildingQuote?: Maybe<Scalars['Float']>;
  calculationId?: Maybe<Scalars['String']>;
  coverages: Array<StandardizedCoverage>;
  householdQuote?: Maybe<Scalars['Float']>;
  installmentsCalculationId?: Maybe<Scalars['String']>;
  installmentsPremium?: Maybe<Scalars['Float']>;
  packageCode: Scalars['String'];
  packageName: Scalars['String'];
  policyDuration: Scalars['Float'];
  policyStartDate: Scalars['String'];
  sessionId?: Maybe<Scalars['String']>;
  singleCalculationId?: Maybe<Scalars['String']>;
  singlePremium?: Maybe<Scalars['Float']>;
  totalPremium: Scalars['Float'];
};

export type StandardizedRisk = {
  __typename?: 'StandardizedRisk';
  claims?: Maybe<Array<StandardizedClaims>>;
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  insuredAmount?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  premium?: Maybe<Scalars['Float']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  calculationResult: CalculationResultEvent;
};


export type SubscriptionCalculationResultArgs = {
  subscriptionId: Scalars['String'];
};

export type VoucherValidateResponseDto = {
  __typename?: 'VoucherValidateResponseDto';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  voucherDescription?: Maybe<Scalars['String']>;
  voucherLabels?: Maybe<Array<Scalars['String']>>;
  voucherValue?: Maybe<Scalars['Float']>;
};

export type WsPayPaymentDetailsDto = {
  __typename?: 'WSPayPaymentDetailsDto';
  CancelURL: Scalars['String'];
  CustomerAddress: Scalars['String'];
  CustomerCity: Scalars['String'];
  CustomerCountry: Scalars['String'];
  CustomerEmail: Scalars['String'];
  CustomerFirstName: Scalars['String'];
  CustomerLastName: Scalars['String'];
  CustomerPhone: Scalars['String'];
  CustomerZIP: Scalars['String'];
  Iframe: Scalars['String'];
  IframeResponseTarget: Scalars['String'];
  PaymentMethod: Scalars['String'];
  PaymentPlan?: Maybe<Scalars['String']>;
  ReturnErrorURL: Scalars['String'];
  ReturnURL: Scalars['String'];
  ShopID: Scalars['String'];
  ShoppingCartID: Scalars['String'];
  Signature: Scalars['String'];
  TotalAmount: Scalars['String'];
  Version: Scalars['String'];
};

export type WsPayResponseDto = {
  __typename?: 'WSPayResponseDto';
  wsPayAmount: Scalars['String'];
  wsPayApprovalCode: Scalars['String'];
  wsPayConfirmationSignature: Scalars['String'];
  wsPayCreditCardNumber: Scalars['String'];
  wsPayCustomerFirstName: Scalars['String'];
  wsPayCustomerLastName: Scalars['String'];
  wsPayDateTime: Scalars['String'];
  wsPayOrderId: Scalars['String'];
  wsPayPartner: Scalars['String'];
  wsPayPaymentPlan: Scalars['String'];
  wsPayPaymentType: Scalars['String'];
  wsPaySTAN: Scalars['String'];
  wsPayShoppingCartId: Scalars['String'];
  wsPaySuccess: Scalars['String'];
};

export type WsPayResp = {
  wsPayAmount: Scalars['String'];
  wsPayApprovalCode: Scalars['String'];
  wsPayConfirmationSignature: Scalars['String'];
  wsPayCreditCardNumber: Scalars['String'];
  wsPayCustomerFirstName: Scalars['String'];
  wsPayCustomerLastName: Scalars['String'];
  wsPayDateTime: Scalars['String'];
  wsPayOrderId: Scalars['String'];
  wsPayPartner: Scalars['String'];
  wsPayPaymentPlan: Scalars['String'];
  wsPayPaymentType: Scalars['String'];
  wsPaySTAN: Scalars['String'];
  wsPayShoppingCartId: Scalars['String'];
  wsPaySuccess: Scalars['String'];
};

export type AcceptTermsMutationVariables = Exact<{
  id: Scalars['String'];
  offerId: Scalars['String'];
  consent: ConsentInput;
  input: SetContractorAndInsuredPersonInput;
  calculationInput?: InputMaybe<CalculationInput>;
}>;


export type AcceptTermsMutation = { __typename?: 'Mutation', acceptTerms: boolean };

export type CallMeMutationVariables = Exact<{
  input: CallMeInput;
}>;


export type CallMeMutation = { __typename?: 'Mutation', callMe: boolean };

export type CreateOfferMutationVariables = Exact<{
  data: CreateOfferInput;
}>;


export type CreateOfferMutation = { __typename?: 'Mutation', createOffer?: { __typename?: 'GetOfferDto', _id: string, offerNumber: string, status: string, soId: string, productTypeId: string, departmentCode?: string | null, productTypeSpecific: { __typename?: 'OfferProductTypeSpecificDto', shoppingCartId: number, attachedDocuments?: Array<string> | null, termsAndConditions?: Array<string> | null, brandId: { __typename?: 'BrandDto', code: string, name: string }, building: { __typename?: 'BuildingDto', package: { __typename?: 'PackageDto', productId?: string | null, code: string, label: string, description: string, propertyType: Array<string> }, coverages: Array<{ __typename?: 'CoverageDto', code: string, label: string, description: string }> }, household: { __typename?: 'HouseholdDto', package: { __typename?: 'PackageDto', productId?: string | null, code: string, label: string, description: string, propertyType: Array<string> }, coverages: Array<{ __typename?: 'CoverageDto', code: string, label: string, description: string }> }, payment: { __typename?: 'PaymentDto', basePremium: number, discount: number, totalPremium: number }, newPolicy: Array<{ __typename?: 'NewPolicyDto', newPolicyStartDate: string, policyDuration: number, cancelContract?: boolean | null }> } } | null };

export type CreateSoMutationVariables = Exact<{
  input: CreateSoInput;
}>;


export type CreateSoMutation = { __typename?: 'Mutation', createSo: string };

export type FinishOfflinePurchaseMutationVariables = Exact<{
  offerId: Scalars['String'];
}>;


export type FinishOfflinePurchaseMutation = { __typename?: 'Mutation', finishOfflinePurchase?: boolean | null };

export type FinishPaymentMutationVariables = Exact<{
  offerId: Scalars['String'];
  wsPayParams: WsPayResp;
}>;


export type FinishPaymentMutation = { __typename?: 'Mutation', finishPayment?: { __typename?: 'FinishPaymentResponse', success: boolean, alreadyPaid?: boolean | null, message: string, policyNumber?: string | null } | null };

export type RecordPaymentErrorMutationVariables = Exact<{
  offerId: Scalars['String'];
  errorCode: Scalars['String'];
  errorMessage: Scalars['String'];
}>;


export type RecordPaymentErrorMutation = { __typename?: 'Mutation', recordPaymentError?: boolean | null };

export type RemoveVoucherMutationVariables = Exact<{
  offerId: Scalars['String'];
}>;


export type RemoveVoucherMutation = { __typename?: 'Mutation', removeVoucher?: boolean | null };

export type SendGeneralTransferDetailsToEmailMutationVariables = Exact<{
  offerId: Scalars['String'];
  installments: Scalars['Int'];
}>;


export type SendGeneralTransferDetailsToEmailMutation = { __typename?: 'Mutation', sendGeneralTransferDetailsToEmail?: string | null };

export type StartCalculationsMutationVariables = Exact<{
  input: CalculationInput;
  subscriptionId: Scalars['String'];
}>;


export type StartCalculationsMutation = { __typename?: 'Mutation', startCalculations: Array<{ __typename?: 'CalculationResultEvent', subscriptionId: string, brandCode: string, isLast: boolean }> };

export type ValidateVoucherMutationVariables = Exact<{
  offerId: Scalars['String'];
  voucherCode: Scalars['String'];
}>;


export type ValidateVoucherMutation = { __typename?: 'Mutation', validateVoucher?: { __typename?: 'VoucherValidateResponseDto', status?: string | null, message?: string | null, voucherDescription?: string | null, voucherLabels?: Array<string> | null, voucherValue?: number | null } | null };

export type GetAdminsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminsQuery = { __typename?: 'Query', getAdmins?: Array<{ __typename?: 'AdminDto', avatar?: string | null }> | null };

export type GetCalculationByBrandQueryVariables = Exact<{
  input: CalculationInput;
  brandCode: Scalars['String'];
}>;


export type GetCalculationByBrandQuery = { __typename?: 'Query', getCalculationByBrand: { __typename?: 'PropertyBrandWithProducts', _id: string, code: string, ptsLogo?: string | null, name: string, products: Array<{ __typename?: 'PropertyProductWithCalculation', _id: string, name: string, code: string, actionLabel?: string | null, productTypeSpecific: { __typename?: 'ProductProductTypeSpecificDto', coverages: Array<{ __typename?: 'ProductPropertyCoverageDto', code?: string | null, label?: string | null, description?: string | null, disables?: string | null }>, modifiers?: Array<{ __typename?: 'BrandModifierDto', field: string, fixed?: number | null, min?: number | null, max?: number | null, default: any }> | null }, partnerId?: { __typename?: 'PartnerIdDto', contractor?: string | null, insuredPerson?: string | null } | null, calculation?: { __typename?: 'StandardizedPackage', calculationId?: string | null, sessionId?: string | null, packageCode: string, packageName: string, totalPremium: number, installmentsPremium?: number | null, singlePremium?: number | null, installmentsCalculationId?: string | null, singleCalculationId?: string | null, buildingQuote?: number | null, householdQuote?: number | null, policyStartDate: string, policyDuration: number, coverages: Array<{ __typename?: 'StandardizedCoverage', code: string, name: string, description?: string | null, premium?: number | null, insuredAmount?: number | null, risks?: Array<{ __typename?: 'StandardizedRisk', code: string, name: string, description?: string | null, premium?: number | null, insuredAmount?: number | null, claims?: Array<{ __typename?: 'StandardizedClaims', name: string, premium: number, insuredAmount: number }> | null }> | null }>, additionalCoverages: Array<{ __typename?: 'StandardizedCoverage', code: string, name: string, description?: string | null, premium?: number | null, insuredAmount?: number | null, risks?: Array<{ __typename?: 'StandardizedRisk', code: string, name: string, description?: string | null, premium?: number | null, insuredAmount?: number | null, claims?: Array<{ __typename?: 'StandardizedClaims', name: string, premium: number, insuredAmount: number }> | null }> | null }> } | null }> } };

export type CalculationResultSubscriptionVariables = Exact<{
  subscriptionId: Scalars['String'];
}>;


export type CalculationResultSubscription = { __typename?: 'Subscription', calculationResult: { __typename?: 'CalculationResultEvent', subscriptionId: string, brandCode: string, isLast: boolean, error?: string | null, result?: Array<{ __typename?: 'PropertyBrandWithProducts', _id: string, code: string, ptsLogo?: string | null, name: string, products: Array<{ __typename?: 'PropertyProductWithCalculation', _id: string, code: string, name: string, actionLabel?: string | null, productTypeSpecific: { __typename?: 'ProductProductTypeSpecificDto', coverages: Array<{ __typename?: 'ProductPropertyCoverageDto', code?: string | null, label?: string | null, description?: string | null, disables?: string | null }>, modifiers?: Array<{ __typename?: 'BrandModifierDto', field: string, fixed?: number | null, min?: number | null, max?: number | null, default: any }> | null }, partnerId?: { __typename?: 'PartnerIdDto', contractor?: string | null, insuredPerson?: string | null } | null, calculation?: { __typename?: 'StandardizedPackage', calculationId?: string | null, sessionId?: string | null, packageCode: string, packageName: string, totalPremium: number, installmentsPremium?: number | null, singlePremium?: number | null, singleCalculationId?: string | null, installmentsCalculationId?: string | null, policyStartDate: string, policyDuration: number, buildingQuote?: number | null, householdQuote?: number | null, coverages: Array<{ __typename?: 'StandardizedCoverage', code: string, name: string, description?: string | null, premium?: number | null, insuredAmount?: number | null, risks?: Array<{ __typename?: 'StandardizedRisk', code: string, name: string, description?: string | null, premium?: number | null, insuredAmount?: number | null, claims?: Array<{ __typename?: 'StandardizedClaims', name: string, premium: number, insuredAmount: number }> | null }> | null }>, additionalCoverages: Array<{ __typename?: 'StandardizedCoverage', code: string, name: string, description?: string | null, premium?: number | null, insuredAmount?: number | null, risks?: Array<{ __typename?: 'StandardizedRisk', code: string, name: string, description?: string | null, premium?: number | null, insuredAmount?: number | null, claims?: Array<{ __typename?: 'StandardizedClaims', name: string, premium: number, insuredAmount: number }> | null }> | null }> } | null }> }> | null } };

export type GetGeneralTransferDetailsQueryVariables = Exact<{
  offerId: Scalars['String'];
  installments: Scalars['Int'];
}>;


export type GetGeneralTransferDetailsQuery = { __typename?: 'Query', getGeneralTransferDetails?: { __typename?: 'GeneralTransferDetailsDto', customerAddress?: string | null, customerCity?: string | null, customerCountry: string, customerEmail?: string | null, customerFirstName?: string | null, customerLastName?: string | null, customerOib?: string | null, customerPhone?: string | null, customerZipCode?: string | null, description?: string | null, model?: string | null, numberOfInstallments: number, price: number, recipientAccountNumber?: string | null, recipientAddress?: string | null, recipientCity?: string | null, recipientName?: string | null, recipientZipCode?: string | null, referenceNumber?: string | null, referenceNumberType?: string | null, referencePrefix?: string | null, referenceSuffix?: string | null } | null };

export type GetOfferQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetOfferQuery = { __typename?: 'Query', getOffer?: { __typename?: 'GetOfferDto', _id: string, offerNumber: string, status: string, soId: string, productTypeId: string, departmentCode?: string | null, createdAt?: string | null, updatedAt?: string | null, deleted?: boolean | null, archived?: boolean | null, productTypeSpecific: { __typename?: 'OfferProductTypeSpecificDto', isPublished: boolean, lastPaymentAttempt?: string | null, paidAt?: string | null, policyLengthType?: string | null, numberOfInstallments?: number | null, shoppingCartId: number, attachedDocuments?: Array<string> | null, termsAndConditions?: Array<string> | null, building: { __typename?: 'BuildingDto', package: { __typename?: 'PackageDto', productId?: string | null, code: string, label: string, description: string, propertyType: Array<string> }, coverages: Array<{ __typename?: 'CoverageDto', code: string, label: string, description: string }> }, household: { __typename?: 'HouseholdDto', package: { __typename?: 'PackageDto', productId?: string | null, code: string, label: string, description: string, propertyType: Array<string> }, coverages: Array<{ __typename?: 'CoverageDto', code: string, label: string, description: string }> }, payment: { __typename?: 'PaymentDto', basePremium: number, discount: number, voucher?: string | null, totalPremium: number, singlePremium?: number | null, installmentsPremium?: number | null, paymentMethod: string }, newPolicy: Array<{ __typename?: 'NewPolicyDto', newPolicyStartDate: string, policyDuration: number, cancelContract?: boolean | null }>, calculationData?: { __typename?: 'OfferCalculationDataDto', calculationId?: string | null, packageCode?: string | null, packageName?: string | null, contractId?: string | null, sessionId?: string | null, insuredInterestId?: string | null, contractorId?: string | null, insuredPersonId?: string | null, nonStandardRequestToggle?: boolean | null, isFlood?: boolean | null, commercialDiscount?: boolean | null, coverages?: Array<{ __typename?: 'CalculationCoverageDto', code: string, name: string, description?: string | null, premium?: number | null, insuredAmount?: number | null, risks?: Array<{ __typename?: 'CalculationRisksDto', code: string, name: string, description?: string | null, premium?: number | null, insuredAmount?: number | null, claims?: Array<{ __typename?: 'CalculationClaimsDto', name: string, premium: number, insuredAmount: number }> | null }> | null }> | null, additionalCoverages?: Array<{ __typename?: 'CalculationCoverageDto', code: string, name: string, description?: string | null, premium?: number | null, insuredAmount?: number | null, risks?: Array<{ __typename?: 'CalculationRisksDto', code: string, name: string, description?: string | null, premium?: number | null, insuredAmount?: number | null, claims?: Array<{ __typename?: 'CalculationClaimsDto', name: string, premium: number, insuredAmount: number }> | null }> | null }> | null } | null, brandId: { __typename?: 'BrandDto', code: string, name: string } } } | null };

export type GetFilesFromOfferQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetFilesFromOfferQuery = { __typename?: 'Query', getFilesFromOffer?: { __typename?: 'OfferFilesGetDto', documents: Array<{ __typename?: 'OfferFileDocumentDto', fileId: string, fileName: string, downloadLink: string }> } | null };

export type GetOffersBySoQueryVariables = Exact<{
  soId: Scalars['String'];
}>;


export type GetOffersBySoQuery = { __typename?: 'Query', getOffersBySo?: { __typename?: 'GetOffersBySoDto', offers: Array<{ __typename?: 'GetOfferDto', _id: string, offerNumber: string, status: string, soId: string, productTypeId: string, departmentCode?: string | null, createdAt?: string | null, updatedAt?: string | null, deleted?: boolean | null, archived?: boolean | null, productTypeSpecific: { __typename?: 'OfferProductTypeSpecificDto', isPublished: boolean, lastPaymentAttempt?: string | null, paidAt?: string | null, policyLengthType?: string | null, numberOfInstallments?: number | null, shoppingCartId: number, attachedDocuments?: Array<string> | null, termsAndConditions?: Array<string> | null, building: { __typename?: 'BuildingDto', quote?: number | null, package: { __typename?: 'PackageDto', productId?: string | null, code: string, label: string, description: string, propertyType: Array<string> }, coverages: Array<{ __typename?: 'CoverageDto', code: string, label: string, description: string }> }, household: { __typename?: 'HouseholdDto', quote?: number | null, package: { __typename?: 'PackageDto', productId?: string | null, code: string, label: string, description: string, propertyType: Array<string> }, coverages: Array<{ __typename?: 'CoverageDto', code: string, label: string, description: string }> }, payment: { __typename?: 'PaymentDto', basePremium: number, discount: number, totalPremium: number, singlePremium?: number | null, installmentsPremium?: number | null, paymentMethod: string }, newPolicy: Array<{ __typename?: 'NewPolicyDto', newPolicyStartDate: string, policyDuration: number, newPolicyEndDate?: string | null, cancelContract?: boolean | null }>, calculationData?: { __typename?: 'OfferCalculationDataDto', calculationId?: string | null, packageCode?: string | null, packageName?: string | null, contractId?: string | null, sessionId?: string | null, insuredInterestId?: string | null, contractorId?: string | null, insuredPersonId?: string | null, nonStandardRequestToggle?: boolean | null, isFlood?: boolean | null, commercialDiscount?: boolean | null, coverages?: Array<{ __typename?: 'CalculationCoverageDto', code: string, name: string, description?: string | null, premium?: number | null, insuredAmount?: number | null, risks?: Array<{ __typename?: 'CalculationRisksDto', code: string, name: string, description?: string | null, premium?: number | null, insuredAmount?: number | null, claims?: Array<{ __typename?: 'CalculationClaimsDto', name: string, premium: number, insuredAmount: number }> | null }> | null }> | null, additionalCoverages?: Array<{ __typename?: 'CalculationCoverageDto', code: string, name: string, description?: string | null, premium?: number | null, insuredAmount?: number | null, risks?: Array<{ __typename?: 'CalculationRisksDto', code: string, name: string, description?: string | null, premium?: number | null, insuredAmount?: number | null, claims?: Array<{ __typename?: 'CalculationClaimsDto', name: string, premium: number, insuredAmount: number }> | null }> | null }> | null } | null, brandId: { __typename?: 'BrandDto', code: string, name: string, logos?: { __typename?: 'BrandLogoDto', dzo?: { __typename?: 'BrandLogoDzoDto', details?: string | null } | null } | null } } }> } | null };

export type GetSoQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSoQuery = { __typename?: 'Query', getSo?: { __typename?: 'GetSoDto', _id: string, encryptedId?: string | null, soNumber: number, status: string, departmentCode?: string | null, source?: string | null, priority?: number | null, hotProspect?: boolean | null, partnerId?: string | null, partnerAdvisorId?: string | null, createdAt?: string | null, updatedAt?: string | null, termsAcceptedAt?: string | null, deleted?: boolean | null, archived?: boolean | null, data?: { __typename?: 'SoDataDto', firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, partner?: string | null } | null, customerId?: { __typename?: 'SoCustomerDto', _id?: string | null, email?: string | null, firstName?: string | null, lastName?: string | null } | null, productTypeId?: { __typename?: 'SoProductTypeDto', _id?: string | null, code?: string | null, name?: string | null, departmentCode?: string | null } | null, productTypeSpecific?: { __typename?: 'SoProductTypeSpecificDto', expectedCommissionAmount?: number | null, propertyInfo?: { __typename?: 'SoPropertyInfoDto', type?: string | null, cityKompareId?: string | null, streetKompareId?: string | null, cityParentName?: string | null, zipCode?: number | null, city?: string | null, street?: string | null, houseNumber?: string | null, area?: number | null, floor?: Array<string> | null, usage?: string | null, masonry?: boolean | null, nonstandardRequests?: string | null, constructionYear?: { __typename?: 'SoPropertyConstructionYearDto', exactYear: number, before1964: boolean } | null } | null, insuranceNeeds?: { __typename?: 'SoPropertyInsuranceNeedsDto', building?: boolean | null, personalProperty?: boolean | null, risks?: Array<string> | null } | null, contractor?: { __typename?: 'SoPropertyContractorDto', type?: PersonType | null, sameAsInsured?: boolean | null, firstName?: string | null, lastName?: string | null, companyName?: string | null, oib?: string | null, dateOfBirth?: string | null, gender?: string | null, email?: string | null, phoneNumber?: string | null, sameAddressAsProperty?: boolean | null, zipCode?: number | null, city?: string | null, street?: string | null, houseNumber?: string | null, cityKompareId?: string | null, streetKompareId?: string | null } | null, insured?: { __typename?: 'SoPropertyPersonDto', type?: PersonType | null, firstName?: string | null, lastName?: string | null, companyName?: string | null, oib?: string | null, dateOfBirth?: string | null, gender?: string | null, email?: string | null, phoneNumber?: string | null, sameAddressAsProperty?: boolean | null, zipCode?: number | null, city?: string | null, street?: string | null, houseNumber?: string | null, cityKompareId?: string | null, streetKompareId?: string | null } | null } | null, funnel?: { __typename?: 'SoFunnelDto', latestStep?: string | null, steps?: Array<{ __typename?: 'SoFunnelStepDto', code: string, openedAt: string }> | null } | null, flags?: { __typename?: 'SoFlagsDto', offerCreated?: boolean | null, offerDocumentSent?: boolean | null, offerDocumentAccepted?: boolean | null, archived?: boolean | null, incomplete?: boolean | null, incompleteResolved?: boolean | null } | null } | null };

export type GetTermsAndConditionsForOfferQueryVariables = Exact<{
  data: OfferTermsAndConditionsInput;
  id?: InputMaybe<Scalars['String']>;
}>;


export type GetTermsAndConditionsForOfferQuery = { __typename?: 'Query', getTermsAndConditionsForOffer?: { __typename?: 'OfferTermsAndConditionsGetDto', brandName: string, brandCode: string, brandLogo?: string | null, productName: string, documents: Array<{ __typename?: 'OfferTermsAndConditionsDocumentDto', fileId: string, fileName: string, src: string }> } | null };

export type GetWsPayPaymentDetailsQueryVariables = Exact<{
  id: Scalars['String'];
  paymentType: Scalars['String'];
  installments?: InputMaybe<Scalars['Int']>;
}>;


export type GetWsPayPaymentDetailsQuery = { __typename?: 'Query', getWSPayPaymentDetails?: { __typename?: 'WSPayPaymentDetailsDto', ShopID: string, ShoppingCartID: string, TotalAmount: string, Signature: string, PaymentPlan?: string | null, ReturnURL: string, CancelURL: string, ReturnErrorURL: string, CustomerFirstName: string, CustomerLastName: string, CustomerAddress: string, CustomerCity: string, CustomerZIP: string, CustomerCountry: string, CustomerPhone: string, CustomerEmail: string, PaymentMethod: string, Iframe: string, IframeResponseTarget: string, Version: string } | null };


export const AcceptTermsDocument = gql`
    mutation AcceptTerms($id: String!, $offerId: String!, $consent: ConsentInput!, $input: SetContractorAndInsuredPersonInput!, $calculationInput: CalculationInput) {
  acceptTerms(
    id: $id
    offerId: $offerId
    consent: $consent
    input: $input
    calculationInput: $calculationInput
  )
}
    `;
export type AcceptTermsMutationFn = Apollo.MutationFunction<AcceptTermsMutation, AcceptTermsMutationVariables>;

/**
 * __useAcceptTermsMutation__
 *
 * To run a mutation, you first call `useAcceptTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptTermsMutation, { data, loading, error }] = useAcceptTermsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      offerId: // value for 'offerId'
 *      consent: // value for 'consent'
 *      input: // value for 'input'
 *      calculationInput: // value for 'calculationInput'
 *   },
 * });
 */
export function useAcceptTermsMutation(baseOptions?: Apollo.MutationHookOptions<AcceptTermsMutation, AcceptTermsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptTermsMutation, AcceptTermsMutationVariables>(AcceptTermsDocument, options);
      }
export type AcceptTermsMutationHookResult = ReturnType<typeof useAcceptTermsMutation>;
export type AcceptTermsMutationResult = Apollo.MutationResult<AcceptTermsMutation>;
export type AcceptTermsMutationOptions = Apollo.BaseMutationOptions<AcceptTermsMutation, AcceptTermsMutationVariables>;
export const CallMeDocument = gql`
    mutation CallMe($input: CallMeInput!) {
  callMe(input: $input)
}
    `;
export type CallMeMutationFn = Apollo.MutationFunction<CallMeMutation, CallMeMutationVariables>;

/**
 * __useCallMeMutation__
 *
 * To run a mutation, you first call `useCallMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCallMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [callMeMutation, { data, loading, error }] = useCallMeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCallMeMutation(baseOptions?: Apollo.MutationHookOptions<CallMeMutation, CallMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CallMeMutation, CallMeMutationVariables>(CallMeDocument, options);
      }
export type CallMeMutationHookResult = ReturnType<typeof useCallMeMutation>;
export type CallMeMutationResult = Apollo.MutationResult<CallMeMutation>;
export type CallMeMutationOptions = Apollo.BaseMutationOptions<CallMeMutation, CallMeMutationVariables>;
export const CreateOfferDocument = gql`
    mutation CreateOffer($data: CreateOfferInput!) {
  createOffer(data: $data) {
    _id
    offerNumber
    status
    soId
    productTypeId
    departmentCode
    productTypeSpecific {
      brandId {
        code
        name
      }
      shoppingCartId
      building {
        package {
          productId
          code
          label
          description
          propertyType
        }
        coverages {
          code
          label
          description
        }
      }
      household {
        package {
          productId
          code
          label
          description
          propertyType
        }
        coverages {
          code
          label
          description
        }
      }
      payment {
        basePremium
        discount
        totalPremium
      }
      newPolicy {
        newPolicyStartDate
        policyDuration
        cancelContract
      }
      attachedDocuments
      termsAndConditions
    }
  }
}
    `;
export type CreateOfferMutationFn = Apollo.MutationFunction<CreateOfferMutation, CreateOfferMutationVariables>;

/**
 * __useCreateOfferMutation__
 *
 * To run a mutation, you first call `useCreateOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOfferMutation, { data, loading, error }] = useCreateOfferMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateOfferMutation(baseOptions?: Apollo.MutationHookOptions<CreateOfferMutation, CreateOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOfferMutation, CreateOfferMutationVariables>(CreateOfferDocument, options);
      }
export type CreateOfferMutationHookResult = ReturnType<typeof useCreateOfferMutation>;
export type CreateOfferMutationResult = Apollo.MutationResult<CreateOfferMutation>;
export type CreateOfferMutationOptions = Apollo.BaseMutationOptions<CreateOfferMutation, CreateOfferMutationVariables>;
export const CreateSoDocument = gql`
    mutation CreateSo($input: CreateSoInput!) {
  createSo(input: $input)
}
    `;
export type CreateSoMutationFn = Apollo.MutationFunction<CreateSoMutation, CreateSoMutationVariables>;

/**
 * __useCreateSoMutation__
 *
 * To run a mutation, you first call `useCreateSoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSoMutation, { data, loading, error }] = useCreateSoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSoMutation(baseOptions?: Apollo.MutationHookOptions<CreateSoMutation, CreateSoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSoMutation, CreateSoMutationVariables>(CreateSoDocument, options);
      }
export type CreateSoMutationHookResult = ReturnType<typeof useCreateSoMutation>;
export type CreateSoMutationResult = Apollo.MutationResult<CreateSoMutation>;
export type CreateSoMutationOptions = Apollo.BaseMutationOptions<CreateSoMutation, CreateSoMutationVariables>;
export const FinishOfflinePurchaseDocument = gql`
    mutation FinishOfflinePurchase($offerId: String!) {
  finishOfflinePurchase(offerId: $offerId)
}
    `;
export type FinishOfflinePurchaseMutationFn = Apollo.MutationFunction<FinishOfflinePurchaseMutation, FinishOfflinePurchaseMutationVariables>;

/**
 * __useFinishOfflinePurchaseMutation__
 *
 * To run a mutation, you first call `useFinishOfflinePurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishOfflinePurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishOfflinePurchaseMutation, { data, loading, error }] = useFinishOfflinePurchaseMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useFinishOfflinePurchaseMutation(baseOptions?: Apollo.MutationHookOptions<FinishOfflinePurchaseMutation, FinishOfflinePurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishOfflinePurchaseMutation, FinishOfflinePurchaseMutationVariables>(FinishOfflinePurchaseDocument, options);
      }
export type FinishOfflinePurchaseMutationHookResult = ReturnType<typeof useFinishOfflinePurchaseMutation>;
export type FinishOfflinePurchaseMutationResult = Apollo.MutationResult<FinishOfflinePurchaseMutation>;
export type FinishOfflinePurchaseMutationOptions = Apollo.BaseMutationOptions<FinishOfflinePurchaseMutation, FinishOfflinePurchaseMutationVariables>;
export const FinishPaymentDocument = gql`
    mutation FinishPayment($offerId: String!, $wsPayParams: WsPayResp!) {
  finishPayment(offerId: $offerId, wsPayParams: $wsPayParams) {
    success
    alreadyPaid
    message
    policyNumber
  }
}
    `;
export type FinishPaymentMutationFn = Apollo.MutationFunction<FinishPaymentMutation, FinishPaymentMutationVariables>;

/**
 * __useFinishPaymentMutation__
 *
 * To run a mutation, you first call `useFinishPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishPaymentMutation, { data, loading, error }] = useFinishPaymentMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *      wsPayParams: // value for 'wsPayParams'
 *   },
 * });
 */
export function useFinishPaymentMutation(baseOptions?: Apollo.MutationHookOptions<FinishPaymentMutation, FinishPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishPaymentMutation, FinishPaymentMutationVariables>(FinishPaymentDocument, options);
      }
export type FinishPaymentMutationHookResult = ReturnType<typeof useFinishPaymentMutation>;
export type FinishPaymentMutationResult = Apollo.MutationResult<FinishPaymentMutation>;
export type FinishPaymentMutationOptions = Apollo.BaseMutationOptions<FinishPaymentMutation, FinishPaymentMutationVariables>;
export const RecordPaymentErrorDocument = gql`
    mutation RecordPaymentError($offerId: String!, $errorCode: String!, $errorMessage: String!) {
  recordPaymentError(
    offerId: $offerId
    errorCode: $errorCode
    errorMessage: $errorMessage
  )
}
    `;
export type RecordPaymentErrorMutationFn = Apollo.MutationFunction<RecordPaymentErrorMutation, RecordPaymentErrorMutationVariables>;

/**
 * __useRecordPaymentErrorMutation__
 *
 * To run a mutation, you first call `useRecordPaymentErrorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordPaymentErrorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordPaymentErrorMutation, { data, loading, error }] = useRecordPaymentErrorMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *      errorCode: // value for 'errorCode'
 *      errorMessage: // value for 'errorMessage'
 *   },
 * });
 */
export function useRecordPaymentErrorMutation(baseOptions?: Apollo.MutationHookOptions<RecordPaymentErrorMutation, RecordPaymentErrorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordPaymentErrorMutation, RecordPaymentErrorMutationVariables>(RecordPaymentErrorDocument, options);
      }
export type RecordPaymentErrorMutationHookResult = ReturnType<typeof useRecordPaymentErrorMutation>;
export type RecordPaymentErrorMutationResult = Apollo.MutationResult<RecordPaymentErrorMutation>;
export type RecordPaymentErrorMutationOptions = Apollo.BaseMutationOptions<RecordPaymentErrorMutation, RecordPaymentErrorMutationVariables>;
export const RemoveVoucherDocument = gql`
    mutation RemoveVoucher($offerId: String!) {
  removeVoucher(offerId: $offerId)
}
    `;
export type RemoveVoucherMutationFn = Apollo.MutationFunction<RemoveVoucherMutation, RemoveVoucherMutationVariables>;

/**
 * __useRemoveVoucherMutation__
 *
 * To run a mutation, you first call `useRemoveVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeVoucherMutation, { data, loading, error }] = useRemoveVoucherMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useRemoveVoucherMutation(baseOptions?: Apollo.MutationHookOptions<RemoveVoucherMutation, RemoveVoucherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveVoucherMutation, RemoveVoucherMutationVariables>(RemoveVoucherDocument, options);
      }
export type RemoveVoucherMutationHookResult = ReturnType<typeof useRemoveVoucherMutation>;
export type RemoveVoucherMutationResult = Apollo.MutationResult<RemoveVoucherMutation>;
export type RemoveVoucherMutationOptions = Apollo.BaseMutationOptions<RemoveVoucherMutation, RemoveVoucherMutationVariables>;
export const SendGeneralTransferDetailsToEmailDocument = gql`
    mutation SendGeneralTransferDetailsToEmail($offerId: String!, $installments: Int!) {
  sendGeneralTransferDetailsToEmail(
    offerId: $offerId
    installments: $installments
  )
}
    `;
export type SendGeneralTransferDetailsToEmailMutationFn = Apollo.MutationFunction<SendGeneralTransferDetailsToEmailMutation, SendGeneralTransferDetailsToEmailMutationVariables>;

/**
 * __useSendGeneralTransferDetailsToEmailMutation__
 *
 * To run a mutation, you first call `useSendGeneralTransferDetailsToEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendGeneralTransferDetailsToEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendGeneralTransferDetailsToEmailMutation, { data, loading, error }] = useSendGeneralTransferDetailsToEmailMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *      installments: // value for 'installments'
 *   },
 * });
 */
export function useSendGeneralTransferDetailsToEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendGeneralTransferDetailsToEmailMutation, SendGeneralTransferDetailsToEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendGeneralTransferDetailsToEmailMutation, SendGeneralTransferDetailsToEmailMutationVariables>(SendGeneralTransferDetailsToEmailDocument, options);
      }
export type SendGeneralTransferDetailsToEmailMutationHookResult = ReturnType<typeof useSendGeneralTransferDetailsToEmailMutation>;
export type SendGeneralTransferDetailsToEmailMutationResult = Apollo.MutationResult<SendGeneralTransferDetailsToEmailMutation>;
export type SendGeneralTransferDetailsToEmailMutationOptions = Apollo.BaseMutationOptions<SendGeneralTransferDetailsToEmailMutation, SendGeneralTransferDetailsToEmailMutationVariables>;
export const StartCalculationsDocument = gql`
    mutation StartCalculations($input: CalculationInput!, $subscriptionId: String!) {
  startCalculations(input: $input, subscriptionId: $subscriptionId) {
    subscriptionId
    brandCode
    isLast
  }
}
    `;
export type StartCalculationsMutationFn = Apollo.MutationFunction<StartCalculationsMutation, StartCalculationsMutationVariables>;

/**
 * __useStartCalculationsMutation__
 *
 * To run a mutation, you first call `useStartCalculationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCalculationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCalculationsMutation, { data, loading, error }] = useStartCalculationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useStartCalculationsMutation(baseOptions?: Apollo.MutationHookOptions<StartCalculationsMutation, StartCalculationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartCalculationsMutation, StartCalculationsMutationVariables>(StartCalculationsDocument, options);
      }
export type StartCalculationsMutationHookResult = ReturnType<typeof useStartCalculationsMutation>;
export type StartCalculationsMutationResult = Apollo.MutationResult<StartCalculationsMutation>;
export type StartCalculationsMutationOptions = Apollo.BaseMutationOptions<StartCalculationsMutation, StartCalculationsMutationVariables>;
export const ValidateVoucherDocument = gql`
    mutation ValidateVoucher($offerId: String!, $voucherCode: String!) {
  validateVoucher(offerId: $offerId, voucherCode: $voucherCode) {
    status
    message
    voucherDescription
    voucherLabels
    voucherValue
  }
}
    `;
export type ValidateVoucherMutationFn = Apollo.MutationFunction<ValidateVoucherMutation, ValidateVoucherMutationVariables>;

/**
 * __useValidateVoucherMutation__
 *
 * To run a mutation, you first call `useValidateVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateVoucherMutation, { data, loading, error }] = useValidateVoucherMutation({
 *   variables: {
 *      offerId: // value for 'offerId'
 *      voucherCode: // value for 'voucherCode'
 *   },
 * });
 */
export function useValidateVoucherMutation(baseOptions?: Apollo.MutationHookOptions<ValidateVoucherMutation, ValidateVoucherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateVoucherMutation, ValidateVoucherMutationVariables>(ValidateVoucherDocument, options);
      }
export type ValidateVoucherMutationHookResult = ReturnType<typeof useValidateVoucherMutation>;
export type ValidateVoucherMutationResult = Apollo.MutationResult<ValidateVoucherMutation>;
export type ValidateVoucherMutationOptions = Apollo.BaseMutationOptions<ValidateVoucherMutation, ValidateVoucherMutationVariables>;
export const GetAdminsDocument = gql`
    query GetAdmins {
  getAdmins {
    avatar
  }
}
    `;

/**
 * __useGetAdminsQuery__
 *
 * To run a query within a React component, call `useGetAdminsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminsQuery, GetAdminsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminsQuery, GetAdminsQueryVariables>(GetAdminsDocument, options);
      }
export function useGetAdminsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminsQuery, GetAdminsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminsQuery, GetAdminsQueryVariables>(GetAdminsDocument, options);
        }
export type GetAdminsQueryHookResult = ReturnType<typeof useGetAdminsQuery>;
export type GetAdminsLazyQueryHookResult = ReturnType<typeof useGetAdminsLazyQuery>;
export type GetAdminsQueryResult = Apollo.QueryResult<GetAdminsQuery, GetAdminsQueryVariables>;
export const GetCalculationByBrandDocument = gql`
    query GetCalculationByBrand($input: CalculationInput!, $brandCode: String!) {
  getCalculationByBrand(input: $input, brandCode: $brandCode) {
    _id
    code
    ptsLogo
    name
    products {
      _id
      name
      code
      actionLabel
      productTypeSpecific {
        coverages {
          code
          label
          description
          disables
        }
        modifiers {
          field
          fixed
          min
          max
          default
        }
      }
      partnerId {
        contractor
        insuredPerson
      }
      calculation {
        calculationId
        sessionId
        packageCode
        packageName
        totalPremium
        installmentsPremium
        singlePremium
        installmentsCalculationId
        singleCalculationId
        buildingQuote
        householdQuote
        policyStartDate
        policyDuration
        coverages {
          code
          name
          description
          premium
          insuredAmount
          risks {
            code
            name
            description
            premium
            insuredAmount
            claims {
              name
              premium
              insuredAmount
            }
          }
        }
        additionalCoverages {
          code
          name
          description
          premium
          insuredAmount
          risks {
            code
            name
            description
            premium
            insuredAmount
            claims {
              name
              premium
              insuredAmount
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCalculationByBrandQuery__
 *
 * To run a query within a React component, call `useGetCalculationByBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalculationByBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalculationByBrandQuery({
 *   variables: {
 *      input: // value for 'input'
 *      brandCode: // value for 'brandCode'
 *   },
 * });
 */
export function useGetCalculationByBrandQuery(baseOptions: Apollo.QueryHookOptions<GetCalculationByBrandQuery, GetCalculationByBrandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCalculationByBrandQuery, GetCalculationByBrandQueryVariables>(GetCalculationByBrandDocument, options);
      }
export function useGetCalculationByBrandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCalculationByBrandQuery, GetCalculationByBrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCalculationByBrandQuery, GetCalculationByBrandQueryVariables>(GetCalculationByBrandDocument, options);
        }
export type GetCalculationByBrandQueryHookResult = ReturnType<typeof useGetCalculationByBrandQuery>;
export type GetCalculationByBrandLazyQueryHookResult = ReturnType<typeof useGetCalculationByBrandLazyQuery>;
export type GetCalculationByBrandQueryResult = Apollo.QueryResult<GetCalculationByBrandQuery, GetCalculationByBrandQueryVariables>;
export const CalculationResultDocument = gql`
    subscription CalculationResult($subscriptionId: String!) {
  calculationResult(subscriptionId: $subscriptionId) {
    subscriptionId
    brandCode
    isLast
    error
    result {
      _id
      code
      ptsLogo
      name
      products {
        _id
        code
        name
        actionLabel
        productTypeSpecific {
          coverages {
            code
            label
            description
            disables
          }
          modifiers {
            field
            fixed
            min
            max
            default
          }
        }
        partnerId {
          contractor
          insuredPerson
        }
        calculation {
          calculationId
          sessionId
          packageCode
          packageName
          totalPremium
          installmentsPremium
          singlePremium
          singleCalculationId
          installmentsCalculationId
          policyStartDate
          policyDuration
          buildingQuote
          householdQuote
          coverages {
            code
            name
            description
            premium
            insuredAmount
            risks {
              code
              name
              description
              premium
              insuredAmount
              claims {
                name
                premium
                insuredAmount
              }
            }
          }
          additionalCoverages {
            code
            name
            description
            premium
            insuredAmount
            risks {
              code
              name
              description
              premium
              insuredAmount
              claims {
                name
                premium
                insuredAmount
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCalculationResultSubscription__
 *
 * To run a query within a React component, call `useCalculationResultSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCalculationResultSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculationResultSubscription({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useCalculationResultSubscription(baseOptions: Apollo.SubscriptionHookOptions<CalculationResultSubscription, CalculationResultSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CalculationResultSubscription, CalculationResultSubscriptionVariables>(CalculationResultDocument, options);
      }
export type CalculationResultSubscriptionHookResult = ReturnType<typeof useCalculationResultSubscription>;
export type CalculationResultSubscriptionResult = Apollo.SubscriptionResult<CalculationResultSubscription>;
export const GetGeneralTransferDetailsDocument = gql`
    query GetGeneralTransferDetails($offerId: String!, $installments: Int!) {
  getGeneralTransferDetails(offerId: $offerId, installments: $installments) {
    customerAddress
    customerCity
    customerCountry
    customerEmail
    customerFirstName
    customerLastName
    customerOib
    customerPhone
    customerZipCode
    description
    model
    numberOfInstallments
    price
    recipientAccountNumber
    recipientAddress
    recipientCity
    recipientName
    recipientZipCode
    referenceNumber
    referenceNumberType
    referencePrefix
    referenceSuffix
  }
}
    `;

/**
 * __useGetGeneralTransferDetailsQuery__
 *
 * To run a query within a React component, call `useGetGeneralTransferDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneralTransferDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneralTransferDetailsQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *      installments: // value for 'installments'
 *   },
 * });
 */
export function useGetGeneralTransferDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetGeneralTransferDetailsQuery, GetGeneralTransferDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeneralTransferDetailsQuery, GetGeneralTransferDetailsQueryVariables>(GetGeneralTransferDetailsDocument, options);
      }
export function useGetGeneralTransferDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeneralTransferDetailsQuery, GetGeneralTransferDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeneralTransferDetailsQuery, GetGeneralTransferDetailsQueryVariables>(GetGeneralTransferDetailsDocument, options);
        }
export type GetGeneralTransferDetailsQueryHookResult = ReturnType<typeof useGetGeneralTransferDetailsQuery>;
export type GetGeneralTransferDetailsLazyQueryHookResult = ReturnType<typeof useGetGeneralTransferDetailsLazyQuery>;
export type GetGeneralTransferDetailsQueryResult = Apollo.QueryResult<GetGeneralTransferDetailsQuery, GetGeneralTransferDetailsQueryVariables>;
export const GetOfferDocument = gql`
    query GetOffer($id: String!) {
  getOffer(id: $id) {
    _id
    offerNumber
    status
    soId
    productTypeId
    departmentCode
    productTypeSpecific {
      isPublished
      building {
        package {
          productId
          code
          label
          description
          propertyType
        }
        coverages {
          code
          label
          description
        }
      }
      household {
        package {
          productId
          code
          label
          description
          propertyType
        }
        coverages {
          code
          label
          description
        }
      }
      payment {
        basePremium
        discount
        voucher
        totalPremium
        singlePremium
        installmentsPremium
        paymentMethod
      }
      newPolicy {
        newPolicyStartDate
        policyDuration
        cancelContract
      }
      calculationData {
        calculationId
        packageCode
        packageName
        contractId
        sessionId
        insuredInterestId
        contractorId
        insuredPersonId
        nonStandardRequestToggle
        isFlood
        commercialDiscount
        coverages {
          code
          name
          description
          premium
          insuredAmount
          risks {
            code
            name
            description
            premium
            insuredAmount
            claims {
              name
              premium
              insuredAmount
            }
          }
        }
        additionalCoverages {
          code
          name
          description
          premium
          insuredAmount
          risks {
            code
            name
            description
            premium
            insuredAmount
            claims {
              name
              premium
              insuredAmount
            }
          }
        }
      }
      lastPaymentAttempt
      paidAt
      policyLengthType
      numberOfInstallments
      brandId {
        code
        name
      }
      shoppingCartId
      attachedDocuments
      termsAndConditions
    }
    createdAt
    updatedAt
    deleted
    archived
  }
}
    `;

/**
 * __useGetOfferQuery__
 *
 * To run a query within a React component, call `useGetOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOfferQuery(baseOptions: Apollo.QueryHookOptions<GetOfferQuery, GetOfferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOfferQuery, GetOfferQueryVariables>(GetOfferDocument, options);
      }
export function useGetOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOfferQuery, GetOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOfferQuery, GetOfferQueryVariables>(GetOfferDocument, options);
        }
export type GetOfferQueryHookResult = ReturnType<typeof useGetOfferQuery>;
export type GetOfferLazyQueryHookResult = ReturnType<typeof useGetOfferLazyQuery>;
export type GetOfferQueryResult = Apollo.QueryResult<GetOfferQuery, GetOfferQueryVariables>;
export const GetFilesFromOfferDocument = gql`
    query GetFilesFromOffer($id: String!) {
  getFilesFromOffer(id: $id) {
    documents {
      fileId
      fileName
      downloadLink
    }
  }
}
    `;

/**
 * __useGetFilesFromOfferQuery__
 *
 * To run a query within a React component, call `useGetFilesFromOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilesFromOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilesFromOfferQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFilesFromOfferQuery(baseOptions: Apollo.QueryHookOptions<GetFilesFromOfferQuery, GetFilesFromOfferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilesFromOfferQuery, GetFilesFromOfferQueryVariables>(GetFilesFromOfferDocument, options);
      }
export function useGetFilesFromOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilesFromOfferQuery, GetFilesFromOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilesFromOfferQuery, GetFilesFromOfferQueryVariables>(GetFilesFromOfferDocument, options);
        }
export type GetFilesFromOfferQueryHookResult = ReturnType<typeof useGetFilesFromOfferQuery>;
export type GetFilesFromOfferLazyQueryHookResult = ReturnType<typeof useGetFilesFromOfferLazyQuery>;
export type GetFilesFromOfferQueryResult = Apollo.QueryResult<GetFilesFromOfferQuery, GetFilesFromOfferQueryVariables>;
export const GetOffersBySoDocument = gql`
    query GetOffersBySo($soId: String!) {
  getOffersBySo(soId: $soId) {
    offers {
      _id
      offerNumber
      status
      soId
      productTypeId
      departmentCode
      productTypeSpecific {
        isPublished
        building {
          package {
            productId
            code
            label
            description
            propertyType
          }
          coverages {
            code
            label
            description
          }
          quote
        }
        household {
          package {
            productId
            code
            label
            description
            propertyType
          }
          coverages {
            code
            label
            description
          }
          quote
        }
        payment {
          basePremium
          discount
          totalPremium
          singlePremium
          installmentsPremium
          paymentMethod
        }
        newPolicy {
          newPolicyStartDate
          policyDuration
          newPolicyEndDate
          cancelContract
        }
        calculationData {
          calculationId
          packageCode
          packageName
          contractId
          sessionId
          insuredInterestId
          contractorId
          insuredPersonId
          nonStandardRequestToggle
          isFlood
          commercialDiscount
          coverages {
            code
            name
            description
            premium
            insuredAmount
            risks {
              code
              name
              description
              premium
              insuredAmount
              claims {
                name
                premium
                insuredAmount
              }
            }
          }
          additionalCoverages {
            code
            name
            description
            premium
            insuredAmount
            risks {
              code
              name
              description
              premium
              insuredAmount
              claims {
                name
                premium
                insuredAmount
              }
            }
          }
        }
        lastPaymentAttempt
        paidAt
        policyLengthType
        numberOfInstallments
        brandId {
          code
          name
          logos {
            dzo {
              details
            }
          }
        }
        shoppingCartId
        attachedDocuments
        termsAndConditions
      }
      createdAt
      updatedAt
      deleted
      archived
    }
  }
}
    `;

/**
 * __useGetOffersBySoQuery__
 *
 * To run a query within a React component, call `useGetOffersBySoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOffersBySoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOffersBySoQuery({
 *   variables: {
 *      soId: // value for 'soId'
 *   },
 * });
 */
export function useGetOffersBySoQuery(baseOptions: Apollo.QueryHookOptions<GetOffersBySoQuery, GetOffersBySoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOffersBySoQuery, GetOffersBySoQueryVariables>(GetOffersBySoDocument, options);
      }
export function useGetOffersBySoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOffersBySoQuery, GetOffersBySoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOffersBySoQuery, GetOffersBySoQueryVariables>(GetOffersBySoDocument, options);
        }
export type GetOffersBySoQueryHookResult = ReturnType<typeof useGetOffersBySoQuery>;
export type GetOffersBySoLazyQueryHookResult = ReturnType<typeof useGetOffersBySoLazyQuery>;
export type GetOffersBySoQueryResult = Apollo.QueryResult<GetOffersBySoQuery, GetOffersBySoQueryVariables>;
export const GetSoDocument = gql`
    query GetSo($id: String!) {
  getSo(id: $id) {
    _id
    encryptedId
    soNumber
    status
    departmentCode
    source
    priority
    hotProspect
    data {
      firstName
      lastName
      email
      phone
      partner
    }
    customerId {
      _id
      email
      firstName
      lastName
    }
    productTypeId {
      _id
      code
      name
      departmentCode
    }
    productTypeSpecific {
      propertyInfo {
        type
        cityKompareId
        streetKompareId
        cityParentName
        zipCode
        city
        street
        houseNumber
        area
        floor
        usage
        masonry
        constructionYear {
          exactYear
          before1964
        }
        nonstandardRequests
      }
      insuranceNeeds {
        building
        personalProperty
        risks
      }
      contractor {
        type
        sameAsInsured
        firstName
        lastName
        companyName
        oib
        dateOfBirth
        gender
        email
        phoneNumber
        sameAddressAsProperty
        zipCode
        city
        street
        houseNumber
        cityKompareId
        streetKompareId
      }
      insured {
        type
        firstName
        lastName
        companyName
        oib
        dateOfBirth
        gender
        email
        phoneNumber
        sameAddressAsProperty
        zipCode
        city
        street
        houseNumber
        cityKompareId
        streetKompareId
      }
      expectedCommissionAmount
    }
    funnel {
      steps {
        code
        openedAt
      }
      latestStep
    }
    flags {
      offerCreated
      offerDocumentSent
      offerDocumentAccepted
      archived
      incomplete
      incompleteResolved
    }
    partnerId
    partnerAdvisorId
    createdAt
    updatedAt
    termsAcceptedAt
    deleted
    archived
  }
}
    `;

/**
 * __useGetSoQuery__
 *
 * To run a query within a React component, call `useGetSoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSoQuery(baseOptions: Apollo.QueryHookOptions<GetSoQuery, GetSoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSoQuery, GetSoQueryVariables>(GetSoDocument, options);
      }
export function useGetSoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSoQuery, GetSoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSoQuery, GetSoQueryVariables>(GetSoDocument, options);
        }
export type GetSoQueryHookResult = ReturnType<typeof useGetSoQuery>;
export type GetSoLazyQueryHookResult = ReturnType<typeof useGetSoLazyQuery>;
export type GetSoQueryResult = Apollo.QueryResult<GetSoQuery, GetSoQueryVariables>;
export const GetTermsAndConditionsForOfferDocument = gql`
    query GetTermsAndConditionsForOffer($data: OfferTermsAndConditionsInput!, $id: String) {
  getTermsAndConditionsForOffer(id: $id, data: $data) {
    brandName
    brandCode
    brandLogo
    productName
    documents {
      fileId
      fileName
      src
    }
  }
}
    `;

/**
 * __useGetTermsAndConditionsForOfferQuery__
 *
 * To run a query within a React component, call `useGetTermsAndConditionsForOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTermsAndConditionsForOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTermsAndConditionsForOfferQuery({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTermsAndConditionsForOfferQuery(baseOptions: Apollo.QueryHookOptions<GetTermsAndConditionsForOfferQuery, GetTermsAndConditionsForOfferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTermsAndConditionsForOfferQuery, GetTermsAndConditionsForOfferQueryVariables>(GetTermsAndConditionsForOfferDocument, options);
      }
export function useGetTermsAndConditionsForOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTermsAndConditionsForOfferQuery, GetTermsAndConditionsForOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTermsAndConditionsForOfferQuery, GetTermsAndConditionsForOfferQueryVariables>(GetTermsAndConditionsForOfferDocument, options);
        }
export type GetTermsAndConditionsForOfferQueryHookResult = ReturnType<typeof useGetTermsAndConditionsForOfferQuery>;
export type GetTermsAndConditionsForOfferLazyQueryHookResult = ReturnType<typeof useGetTermsAndConditionsForOfferLazyQuery>;
export type GetTermsAndConditionsForOfferQueryResult = Apollo.QueryResult<GetTermsAndConditionsForOfferQuery, GetTermsAndConditionsForOfferQueryVariables>;
export const GetWsPayPaymentDetailsDocument = gql`
    query GetWSPayPaymentDetails($id: String!, $paymentType: String!, $installments: Int) {
  getWSPayPaymentDetails(
    id: $id
    paymentType: $paymentType
    installments: $installments
  ) {
    ShopID
    ShoppingCartID
    TotalAmount
    Signature
    PaymentPlan
    ReturnURL
    CancelURL
    ReturnErrorURL
    CustomerFirstName
    CustomerLastName
    CustomerAddress
    CustomerCity
    CustomerZIP
    CustomerCountry
    CustomerPhone
    CustomerEmail
    PaymentMethod
    Iframe
    IframeResponseTarget
    Version
  }
}
    `;

/**
 * __useGetWsPayPaymentDetailsQuery__
 *
 * To run a query within a React component, call `useGetWsPayPaymentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWsPayPaymentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWsPayPaymentDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      paymentType: // value for 'paymentType'
 *      installments: // value for 'installments'
 *   },
 * });
 */
export function useGetWsPayPaymentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetWsPayPaymentDetailsQuery, GetWsPayPaymentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWsPayPaymentDetailsQuery, GetWsPayPaymentDetailsQueryVariables>(GetWsPayPaymentDetailsDocument, options);
      }
export function useGetWsPayPaymentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWsPayPaymentDetailsQuery, GetWsPayPaymentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWsPayPaymentDetailsQuery, GetWsPayPaymentDetailsQueryVariables>(GetWsPayPaymentDetailsDocument, options);
        }
export type GetWsPayPaymentDetailsQueryHookResult = ReturnType<typeof useGetWsPayPaymentDetailsQuery>;
export type GetWsPayPaymentDetailsLazyQueryHookResult = ReturnType<typeof useGetWsPayPaymentDetailsLazyQuery>;
export type GetWsPayPaymentDetailsQueryResult = Apollo.QueryResult<GetWsPayPaymentDetailsQuery, GetWsPayPaymentDetailsQueryVariables>;